import OrderNewScreenComponent from './OrderNewScreenComponent';
import {select} from '../../../store/store';
import {iRootDispatch, iRootState} from '../../../store/store';
import {RouteComponentProps, withRouter} from 'react-router';
import {connect} from 'react-redux';
import {
    COSOrdersStore,
    createNewPayload, sendOrderPayload,
    singleByIdWithKeysPayload,
} from '../../../store/models/COSOrdersModel';
import {
    OrderEditFormData,
    OrderEditFormDataKeys,
} from '../../components/order-edit-form/OrderEditForm';
import {PATH_ORDERS} from '../../../constants/routerPaths';

interface OrderNewScreenStateProps {
}

interface OrderNewScreenDispatchProps {
    createNew?: (payload: createNewPayload) => Promise<{ id?: string }>;
    singleById?: (id?: string) => Promise<OrderEditFormData | undefined>;
    //
    fakeOrderSave?: (id?: string) => Promise<void>;
    sendOrder?: (payload: sendOrderPayload) => Promise<void>

}

const selection = () => select((_models) => ({}));

const mapStateToProps = (
    state: iRootState,
    ownProps: RouteComponentProps<{}>
): OrderNewScreenStateProps => ({
    //
    ...selection()(state),
});

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: OrderNewScreenDispatchProps) =>
    ({
        sendOrder: _dispatch.COSOrders.sendOrder,
        createNew: _dispatch.COSOrders.createNew,
        //
        singleById: (id?: string) =>
            // @ts-ignore
            _dispatch.COSOrders.singleByIdWithKeys<OrderEditFormData>({
                id: id,
                keys: OrderEditFormDataKeys,
            }),
        //
        fakeOrderSave: async (id?: string) => {
            await COSOrdersStore.update(id, {
                state: 'SendingInProgress',
                draftCloseDeadline: new Date(),
            });
            //
            _dispatch.nav.push(PATH_ORDERS);
        },
        //
        ..._ownDispatch,
    } as OrderNewScreenDispatchProps);

type connectedProps = OrderNewScreenStateProps & ReturnType<typeof mapDispatch>;
export type OrderNewScreenProps = connectedProps;

export const OrderNewScreen = withRouter(
    connect(mapStateToProps, mapDispatch as any)(OrderNewScreenComponent)
);
